define('rebrush/components/layout/newsletter-subscribe',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'text!shoptheme/templates/magnific-popup/default.html',
	'magnific-popup'
], function(
	$,
	_,
	Component,
	BEM,
	PopupHtml
) {

	var popupTemplate = null;

	function Plugin(block) {
		this.block = BEM.block(block);
		this.trigger = this.block.getElements('agreement-content-trigger');
		this.contentBlock = this.block.getElements('agreement-content');

		this.bindEvents();
	}

	Plugin.prototype = {
		bindEvents: function() {
			this.trigger.on('click', _.bind(this.showContent, this));
			this.trigger.on('keyup', _.bind(function(e) {
				if (e.key === 'Enter') {
					this.showContent(e);
				}
			}, this));
		},

		showContent: function(e) {
			e.preventDefault();
			e.stopPropagation();

			$.magnificPopup.open({
				// mainClass: 'mfp-full',
				fixedContentPos: true,
				items: {
					src: this._renderPopup({
						body: this.contentBlock.html(),
						displayCloseButton: true
					}),
					type: 'inline'
				},
			});
		},

		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		},
	};

	return Component.create({
		$init: function() {
			new Plugin('newsletter-subscribe');
		}
	});
});
